module.exports = __webpack_public_path__ + "static/media/fondo-slide-3.2401f0b1.jpg";